/** @format */

export const SearchboxJson = {
  headerMessage: [
    { weight: 'light', label: 'Searchbox.header.message1' },
    { weight: 'bold', label: 'Searchbox.header.message2' },
    { weight: 'light', label: 'Searchbox.header.message3' },
  ],

  inputText: [
    { weight: 'light', label: 'Scrivi' },
    { weight: 'bold', label: ' cosa' },
    { weight: 'light', label: ' stai cercando:' },
  ],

  inputPlaceholder: ' ',

  selectText: [
    { weight: 'light', label: 'Seleziona ' },
    { weight: 'bold', label: 'una ' },
    { weight: 'light', label: 'categoria:' },
  ],

  selectItems: {
    name: 'Categoria',
    placeholder: 'Categoria',
    items: [
      { value: 'Categoria1', label: 'Categoria1', id: 1 },
      { value: 'Categoria2', label: 'Categoria2', id: 2 },
      { value: 'Categoria3', label: 'Categoria3', id: 3 },
    ],
  },

  button: 'Searchbox.button',
};
